import CompositionsService from '@/services/Compositions/CompositionsService';
import SubmissionService from '@/services/Submission/SubmissionService';
import { setLocalStorageItem } from '@/helpers/storage';
import stepValidators from './StepValidators';

const COMPANY_TYPE_INPUT = 1;

const INITIAL_BASE_DATA = {
    company: null,
    country: null,
    collection_date: '',
    material: null,
    human_name: '',
    name: '',
    postindustrial: 0,
    postconsumer: 100,
};

const INITIAL_INPUT_SECOND_DATA = {
    prePostConsumer: 'post-c',
    volumeGross: null,
    volumeNet: null,
    contamination: null,
};

const INITIAL_OUTPUT_SECOND_DATA = {
    additives_percentage: 0,
    other_percentage: 0,
    materials: [],
    recycled_content: 0,
};

const INITIAL_VALID_STEPS = {
    1: true,
    2: false,
    3: false,
};


const state = {
    baseData: INITIAL_BASE_DATA,
    inputSecondData: INITIAL_INPUT_SECOND_DATA,
    outputSecondData: INITIAL_OUTPUT_SECOND_DATA,
    validSteps: INITIAL_VALID_STEPS,
    inputCompositionWaste: [],
    lastCompositionInput: {}
};


const actions = {
    async saveWizardInput({ state, commit }, router) {
        const { company, material, country, collection_date } = state.baseData;
        const { code } = country;
        const company_id = company.id;
        const materialName = material.name;
        const materialId = material.id;

        const {
            prePostConsumer,
            volumeGross,
            volumeNet,
            contamination
        } = state.inputSecondData;

        const name = `${materialName} ${prePostConsumer}`;
        const human_name = name;



        const compositionWasteMaterial = {
            material_id: materialId,
            percentage: 100,
            postindustrial: prePostConsumer !== 'post-c' ? 100 : 0,
            postconsumer: prePostConsumer === 'post-c' ? 100 : 0,
            checked: true,
        };

        const compositionData = {
          company_id,
          name,
          human_name,
          additives_percentage: 0,
          other_percentage: 0,
          materials: [compositionWasteMaterial],
          recycled_content: 100,
          type: COMPANY_TYPE_INPUT
        };

        const lastCompositionInput = state.lastCompositionInput;

        if (lastCompositionInput && lastCompositionInput.name) {
            compositionData.name = lastCompositionInput.name;
        }

        const resposne = await CompositionsService.getCompositionByNameAndCompanyId({ name: compositionData.name, company_id });
        const { composition_id } = resposne.data;

        const submissionData = {
            submission_id: null,
            company_id,
            country_code: code,
            collection_date: `${collection_date}-01`,
            volume_gross: volumeGross,
            volume_net: parseInt(volumeNet, 0),
            contamination: parseInt(contamination, 0),
        };

        setLocalStorageItem('last_input', {
            composition: compositionData,
            submission: submissionData
        });
        commit('resetState');

        if (composition_id) {
            submissionData.composition_id = composition_id;
            SubmissionService.createSubmission(submissionData).then(() => {
                router.push({ name: 'user.dashboard' });
            });
        } else {
            const { data } = await CompositionsService.createComposition(compositionData);
            const newComposition = data.composition;
            submissionData.composition_id = newComposition.id;
            SubmissionService.createSubmission(submissionData).then(() => {
                router.push({ name: 'user.dashboard' });
            });
        }

    },
    saveWizardOutput({ state, commit }, router) {
        const { company, name, human_name } = state.baseData;
        const company_id = company.id;
        const {
          additives_percentage,
          other_percentage,
          materials,
          recycled_content
        } = state.outputSecondData;

        const compositionData = {
          company_id,
          name,
          human_name,
          additives_percentage,
          other_percentage,
          materials,
          recycled_content
        };

        return CompositionsService.createComposition(compositionData).then(() => {
            commit('resetState');
            router.push({ name: 'user.dashboard' });
            //commit('setData', result.data);
        });
    },
};

const mutations = {
    setBaseData(state, data) {
        state.baseData = data;
    },
    setBaseDataCollectionDate(state, data) {
        state.baseData.collection_date = data;
    },
    setLastCompositionInput(state, data) {
        state.lastCompositionInput = data;
    },
    setInputCompositionWaste(state, data) {
        state.inputCompositionWaste = data;
    },
    resetLastWaste(state) {
        state.lastCompositionInput = {};
        state.inputCompositionWaste = [];
        state.baseData.collection_date = '';
    },
    setInputSecondData(state, data) {
        state.inputSecondData = data;
    },
    setOutputSecondData(state, data) {
        state.outputSecondData = data;
    },
    setStepsValidation(state, validationData) {
        const { stepId, isValid } = validationData;
        state.validSteps[stepId] = isValid;
    },
    resetState(state) {
        stepValidators.unregisterAll();

        state.baseData = INITIAL_BASE_DATA;
        state.inputSecondData = INITIAL_INPUT_SECOND_DATA;
        state.outputSecondData = INITIAL_OUTPUT_SECOND_DATA;
        state.validSteps = INITIAL_VALID_STEPS;
    }
};

/**
 * Main app store data
 */
export default {
    namespaced: true,
    state,
    actions,
    mutations,
};

//   this.$store.dispatch('userSubmissions/save', submissionData).then(() => {
//     this.$router.push({name: 'user.dashboard'});
//     this.$snotify.success('Submission saved.');
//   });
        // submission_id: NaN
        // company_id: 1
        // country_code: "PL"
        // composition_id: 17
        // collection_date: "undefined 2020 01"
        // volume_gross: "1000"
        // volume_net: 800
